import { render, staticRenderFns } from "./compliance.vue?vue&type=template&id=fc6f20cc"
import script from "./compliance.vue?vue&type=script&lang=js"
export * from "./compliance.vue?vue&type=script&lang=js"
import style0 from "./compliance.vue?vue&type=style&index=0&id=fc6f20cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports